module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Medium.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Medium.eot
 ** module id = 354
 ** module chunks = 0
 **/